import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import config from './config';
import GtagEvents from './utils/GtagEvents'

const app = new modular({
    modules: modules
});

window.onload = (event) => {
    const $style = document.getElementById("stylesheet");

    if(config.IS_MOBILE) {
        html.classList.add('is-mobile');
    }

    if ($style.isLoaded) {
        init();
    } else {
        $style.addEventListener('load', (event) => {
            init();
        });
    }
};


function init() {

    globals();
    app.init(app);

    setTimeout(() => {
        html.classList.add('is-loaded');
        html.classList.add('is-ready');

        html.classList.add('is-first-load');

        setTimeout(() => {
            html.classList.add('is-animated');
            html.classList.add('has-app-first-load');
        }, 1200);

    }, 800);
}

export const GtagHandler = new GtagEvents()
